module.exports = __webpack_public_path__ + "coc-42ef6ed2e16b8ecad29254576cd78d1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/phases/phaseShow/components/cocSignature/coc.jpg
// module id = ZyHx
// module chunks = client